import { FunctionComponentElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  ConfirmDialogIconType,
  ConfirmationDialog,
} from '$components/confirmation-dialog/confirmation-dialog';
import {
  NotificationRuleMode,
  NotificationRuleSubmitForm,
} from '$features/notifications/types';

export interface SuccessScreenProps {
  mode: NotificationRuleMode;
  notiRule?: NotificationRuleSubmitForm;
  notificationRuleId?: string;
}

export function SuccessScreen({
  mode,
  notiRule,
  notificationRuleId,
}: SuccessScreenProps): FunctionComponentElement<SuccessScreenProps> {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const primaryAction = notificationRuleId
    ? {
        label: t('notificationRules.viewRule'),
        onClick: () =>
          navigate(
            `/notifications/notifications-rules?sidecarRoute=notifications&id=${encodeURIComponent(notificationRuleId)}`,
          ),
      }
    : undefined;

  return (
    <>
      {mode === NotificationRuleMode.CREATE && (
        <ConfirmationDialog
          title={t('notificationRules.addSuccessHeadline')}
          iconType={ConfirmDialogIconType.success}
          primaryAction={primaryAction}
          dialogDescription={
            <Trans
              i18nKey="notificationRules.addSuccessMessage"
              values={{
                name: notiRule?.notificationRuleName,
              }}
              components={{ bold: <span className="font-weight-bold" /> }}
            />
          }
        />
      )}
      {mode === NotificationRuleMode.EDIT && (
        <ConfirmationDialog
          title={t('notificationRules.editSuccessHeadline')}
          iconType={ConfirmDialogIconType.success}
          primaryAction={primaryAction}
          dialogDescription={
            <>
              <Trans
                i18nKey="notificationRules.editSuccessMessage"
                values={{
                  name: notiRule?.notificationRuleName,
                }}
                components={{ bold: <span className="font-weight-bold" /> }}
              />

              <p className="m-top-m">
                <Trans
                  i18nKey="notificationRules.editSuccessHint"
                  components={{ bold: <span className="font-weight-bold" /> }}
                />
              </p>
            </>
          }
        />
      )}
    </>
  );
}
